module.exports = __webpack_public_path__ + "static/media/postgres.14d30caf.svg";